import MapImageLayer from 'esri/layers/MapImageLayer';


/**
 * These are the various layers that will be displayed on the map. They cannot be easly moved into another file
 * or location, because the depend on MapImageLayer, which is only available upon the resolution
 * of a promise by the ESRI loader.
 */

// PROD GIS
let ESRI_BASE_URL = 'https://aegis-enterprise.cable.comcast.com/server/rest/services'

const ACTIVE = new MapImageLayer({
    url: ESRI_BASE_URL + '/CC_SNET_HFCNetwork/CC_SNET_RF_ACTIVE/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 20000
});

const TOMBESTONE = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_HFC_DATABLOCK/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 10000
});

const CABLE = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_RF_CABLE/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 20000
});

const TAP = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_RF_TAP/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 20000
});

const PASSIVE = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_RF_PASSIVE/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 20000
});

const STRAND = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_STRAND/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 50000
});

const SUPPORT = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_SUPPORT_STRUCTURE/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 50000
});

const POWERSUPPLY = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_RF_POWERSUPPLY/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 50000
});

const NODE_SITE = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_NODE_SITE/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 20000
});

const NODE_B = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_Boundary/CC_SNET_NODE_BNDY/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 2500000
});

const FIBER = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_FIBER_CABLE/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 2500000
});

const FIBER_SPLICE = new MapImageLayer({
    url: ESRI_BASE_URL +  '/CC_SNET_HFCNetwork/CC_SNET_FIBER_SPLICE/MapServer',
    imageFormat: 'png32',
    maxScale: 0,
    minScale: 2500000
});

export const LAYERS = [
    ACTIVE,
    TOMBESTONE,
    CABLE,
    TAP,
    PASSIVE,
    STRAND,
    SUPPORT,
    POWERSUPPLY,
    NODE_SITE,
    NODE_B,
    FIBER,
    FIBER_SPLICE,
];

